import React from 'react';
import Translate from 'react-translate-component';

import { history } from 'store/browserHistory';
import { NOTIFICATION_ROUTES } from 'constants/routes';
import { pushDescriptionTranslatePath } from 'constants/notificationTypes';

const PushNotification = ({ closeNotification, data }) => {
    const notificationType = data.notificationType;
    const descriptionPath = pushDescriptionTranslatePath[notificationType] || 'notify.emptyList';
    const count = Number(data[notificationType]);

    const redirect = () => {
        const { route } = NOTIFICATION_ROUTES.find(({ type }) => data[type]);

        history.location.pathname !== route && history.push(route);
        closeNotification();
    };

    return count ? (
        <div className='notification-link' onClick={redirect}>
            <Translate content={descriptionPath} with={{ count }} />
        </div>
    ) : null;
};

export default PushNotification;
